import ky from 'ky';
import dayjs from 'dayjs';
import Big from 'big.js';
import { set } from 'lodash-es';
import { BrowserProvider, ethers } from 'ethers';
import { createTxMsgDelegate, createTxMsgUndelegate, createTxMsgMultipleWithdrawDelegatorReward, createTxMsgBeginRedelegate, createTxIBCMsgTransfer } from '@tharsis/transactions';
import * as coin from '@tharsis/proto/dist/proto/cosmos/base/v1beta1/coin';
import coin__default from '@tharsis/proto/dist/proto/cosmos/base/v1beta1/coin';
import eip712_1 from '@tharsis/eip712';
import { createTransactionWithMultipleMessages } from '@tharsis/proto/dist/transaction/transaction';
import pb_1 from 'google-protobuf';
import { recoverPublicKey, computePublicKey } from '@ethersproject/signing-key';
import { hashMessage } from '@ethersproject/hash';
import * as cosmosType from '@tharsis/proto/dist/proto/cosmos/tx/v1beta1/tx';
import { generatePostBodyBroadcast, generateEndpointBroadcast } from '@tharsis/provider';
import { stripHexPrefix, isValidChecksumAddress, toChecksumAddress } from '@mtt/crypto-addr-codec';
import { bech32 } from 'bech32';
import { Buffer as Buffer$1 } from 'buffer';
import proto_1, { createTxRaw } from '@tharsis/proto';
import mitt from 'mitt';
import { deviceDetect } from 'react-device-detect';
import { Keplr } from '@keplr-wallet/provider-extension';
import { SigningStargateClient } from '@cosmjs/stargate';
import * as erc20Type from '@tharsis/proto/dist/proto/evmos/erc20/v1/tx';

if (!Object.hasOwn) {
  Object.hasOwn = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

var WalletCode = /* @__PURE__ */ ((WalletCode2) => {
  WalletCode2[WalletCode2["BASE_FAILURE"] = -1] = "BASE_FAILURE";
  WalletCode2[WalletCode2["BASE_SUCCESS"] = 9999] = "BASE_SUCCESS";
  WalletCode2[WalletCode2["INTERNAL_TIMEOUT"] = 1001] = "INTERNAL_TIMEOUT";
  WalletCode2[WalletCode2["INTERNAL_INSUFFICIENT_GAS"] = 1008] = "INTERNAL_INSUFFICIENT_GAS";
  WalletCode2[WalletCode2["INTERNAL_REDELEGATE_7"] = 1009] = "INTERNAL_REDELEGATE_7";
  WalletCode2[WalletCode2["SERVICE_TIMEOUT"] = 5001] = "SERVICE_TIMEOUT";
  WalletCode2[WalletCode2["THIRD_TXHASH"] = -32602] = "THIRD_TXHASH";
  WalletCode2[WalletCode2["THIRD_SIGNER_LIMIT"] = 13] = "THIRD_SIGNER_LIMIT";
  WalletCode2[WalletCode2["THIRD_SIGNER_NOT_FOUND"] = 5] = "THIRD_SIGNER_NOT_FOUND";
  WalletCode2[WalletCode2["METAMASK_NOT_DEVICE"] = 5101] = "METAMASK_NOT_DEVICE";
  WalletCode2[WalletCode2["METAMASK_NOT_PLUGIN"] = 5102] = "METAMASK_NOT_PLUGIN";
  WalletCode2[WalletCode2["METAMASK_NOT_INSTALL"] = 5103] = "METAMASK_NOT_INSTALL";
  WalletCode2[WalletCode2["METAMASK_CONNECT_ERR"] = 5104] = "METAMASK_CONNECT_ERR";
  return WalletCode2;
})(WalletCode || {});
const walletCodeMessage = {
  [-1 /* BASE_FAILURE */]: "error",
  [9999 /* BASE_SUCCESS */]: "success",
  [1001 /* INTERNAL_TIMEOUT */]: "internal timeout",
  [1008 /* INTERNAL_INSUFFICIENT_GAS */]: "Insufficient balance, please reserve enough gas fee.",
  [1009 /* INTERNAL_REDELEGATE_7 */]: "Redelegation failed, please wait until {time}",
  [5001 /* SERVICE_TIMEOUT */]: "service timeout",
  [-32602 /* THIRD_TXHASH */]: "txHash error",
  [13 /* THIRD_SIGNER_LIMIT */]: "signer error",
  [5 /* THIRD_SIGNER_NOT_FOUND */]: "signer error",
  [5101 /* METAMASK_NOT_DEVICE */]: "wallet cosmos dosen't support mobile",
  [5102 /* METAMASK_NOT_PLUGIN */]: "broswer doesn't support plugin",
  [5103 /* METAMASK_NOT_INSTALL */]: "broswer haven't install plugin",
  [5104 /* METAMASK_CONNECT_ERR */]: "keplr connect error"
};

var __defProp$6 = Object.defineProperty;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$6 = (obj, key, value) => __defNormalProp$6(obj, typeof key !== "symbol" ? key + "" : key, value);
class BaseResult {
  constructor(code, data, msg) {
    __publicField$6(this, "code");
    __publicField$6(this, "msg");
    __publicField$6(this, "data");
    this.code = code;
    this.data = data;
    this.codeHandler(code, data, msg);
  }
  codeHandler(code, data, msg) {
    if (msg) {
      this.msg = msg;
    } else {
      this.msg = walletCodeMessage[code] || "";
    }
    if (code === WalletCode.BASE_FAILURE) {
      if (data && data instanceof Error) {
        this.code = data?.error?.code;
        const message = data?.error?.message;
        this.msg = message || walletCodeMessage[this.code];
      }
      if (data && data instanceof TypeError) {
        const message = data?.message;
        this.msg = message || walletCodeMessage[this.code];
      }
    }
  }
  get isSuccess() {
    return this.code === WalletCode.BASE_SUCCESS;
  }
}
class FailureResult extends BaseResult {
  constructor(data, msg) {
    super(WalletCode.BASE_FAILURE, data, msg);
  }
}
class SuccessResult extends BaseResult {
  constructor(data, msg) {
    super(WalletCode.BASE_SUCCESS, data, msg);
  }
}

const createApiClient = (options = {}) => {
  const apiClient = ky.create({
    // 全局基础配置
    prefixUrl: options.prefixUrl || "",
    // 基础 URL，可选
    headers: {
      "Content-Type": "application/json",
      ...options.headers
      // 支持外部传入的 headers
    },
    timeout: options.timeout || 3e4,
    // 默认超时时间
    hooks: {
      beforeRequest: [
        async (request) => {
          if (options.getToken) {
            const token = await options.getToken();
            if (token) {
              request.headers.set("Authorization", `Bearer ${token}`);
            }
          }
        }
      ],
      afterResponse: [
        async (request, options2, response) => {
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
              `\u8BF7\u6C42\u5931\u8D25: ${response.status} ${response.statusText}, \u9519\u8BEF\u4FE1\u606F: ${JSON.stringify(errorData)}`
            );
          }
          console.log("\u8BF7\u6C42\u6210\u529F:", response.url);
          return response;
        }
      ],
      beforeError: [
        (error) => {
          console.error("\u8BF7\u6C42\u9519\u8BEF:", error.message);
          return error;
        }
      ]
    }
  });
  return apiClient;
};
const getToken = async () => {
  return localStorage.getItem("auth_token");
};
const baseApi = createApiClient({
  prefixUrl: "https://cosmos-rest.mtt.network",
  getToken,
  headers: {}
});
const scopeApi = (scope) => {
  return {
    /**
     * GET 请求
     * @param service 服务路径
     * @returns Promise<any>
     */
    get(service) {
      const url = `${scope}${service}`;
      return baseApi.get(url).then((resp) => resp.json());
    },
    /**
     * POST 请求
     * @param service 服务路径
     * @param req 请求体
     * @returns Promise<any>
     */
    post(service, req) {
      const url = `${scope}${service}`;
      return baseApi.post(url, { json: req }).then((resp) => resp.json());
    },
    /**
     * DELETE 请求
     * @param service 服务路径
     * @returns Promise<any>
     */
    delete(service) {
      const url = `${scope}${service}`;
      return baseApi.delete(url).then((resp) => resp.json());
    }
  };
};

function objectToQueryString(params) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== void 0 && value !== null) {
      searchParams.append(key, value);
    }
  }
  return searchParams.toString();
}
const desensitizeHash = (hash, len = 6) => {
  if (!hash) return "";
  const reg = new RegExp(`(\\w{${len}})\\w*(\\w{${len}})`);
  return hash.replace(reg, "$1...$2");
};

const api$6 = scopeApi("cosmos/staking");
async function getStakingPool() {
  try {
    const stakingResponse = await api$6.get("/v1beta1/pool");
    const stakingPool = stakingResponse.pool;
    const bondedTokens = stakingPool.bonded_tokens;
    const notBondedTokens = stakingPool.not_bonded_tokens;
    return { bondedTokens, notBondedTokens };
  } catch (error) {
    console.error("getStakingPool >>", error);
    return { bondedTokens: "0", notBondedTokens: "0" };
  }
}
async function getStakingPoolValidator() {
  try {
    const url = `/v1beta1/validators?status=BOND_STATUS_BONDED`;
    const stakingResponse = await api$6.get(url);
    const validators = stakingResponse.validators;
    let totalStaked = BigInt(0);
    let totalRewards = BigInt(210000000n / 2n / 4n) * BigInt(10) ** BigInt(18);
    for (const validator of validators) {
      totalStaked += BigInt(validator.tokens);
    }
    return {
      totalStaked: totalStaked.toString(),
      totalRewards: totalRewards.toString()
    };
  } catch (error) {
    console.error("getStakingPoolValidator >>", error);
    return { totalStaked: "0", totalRewards: "0" };
  }
}
async function getStakingsValidators(params) {
  try {
    const queryParams = [];
    if (params.status) {
      queryParams.push(`status=${params.status}`);
    }
    if (params.pagination) {
      const { key, offset, limit, count_total, reverse } = params.pagination;
      if (key) queryParams.push(`pagination.key=${key}`);
      if (offset) queryParams.push(`pagination.offset=${offset}`);
      if (limit) queryParams.push(`pagination.limit=${limit}`);
      if (count_total !== void 0)
        queryParams.push(`pagination.count_total=${count_total}`);
      if (reverse !== void 0)
        queryParams.push(`pagination.reverse=${reverse}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
    const url = `/v1beta1/validators${queryString}`;
    const resp = await api$6.get(url);
    return {
      pagination: resp.pagination,
      list: resp.validators
    };
  } catch (error) {
  }
}
async function getDelegation(params) {
  try {
    const resp = await api$6.get(
      `/v1beta1/validators/${params.validatorAddress}/delegations?pagination.count_total=true`
    );
    return { ...resp };
  } catch (error) {
    return new FailureResult(error);
  }
}
async function getStakingAlltimeVlidator() {
  try {
    const stakingResponse = await api$6.get("/v1beta1/validators");
    return stakingResponse.validators;
  } catch (error) {
    console.error("getStakingAlltimeVlidator >>", error);
    return [];
  }
}
async function getValidator(params) {
  try {
    const resp = await api$6.get(
      `/v1beta1/validators/${params.validatorAddress}`
    );
    return resp.validator;
  } catch (error) {
    return new FailureResult();
  }
}
async function getSelfStakeInfo(params) {
  try {
    const resp = await api$6.get(
      `/v1beta1/delegators/${params.delegatorAddress}/validators/${params.validatorAddress}`
    );
    return resp;
  } catch (error) {
    return new FailureResult();
  }
}
async function getMineDelegatorList(params) {
  try {
    const resp = await api$6.get(
      `/v1beta1/delegations/${params.delegatorAddress}`
    );
    return resp;
  } catch (error) {
    return error;
  }
}
async function getValidatorRecord(params, host) {
  try {
    const req = {
      validator: params.validatorAddress
    };
    if (params.pagination) {
      Object.assign(req, {
        limit: params.pagination.limit,
        offset: params.pagination.offset
      });
    }
    const url = `${host}/validatorHistory?${objectToQueryString(req)}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function getDelegatorRecord(params, host) {
  try {
    const req = {
      delegator: params.delegatorAddress
    };
    if (params.pagination) {
      Object.assign(req, {
        limit: params.pagination.limit,
        offset: params.pagination.offset
      });
    }
    const url = `${host}/delegatorHistory?${objectToQueryString(req)}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function getStakeHistoryRecord(params, host) {
  try {
    const url = `${host}/rewardHistory?validator=${params.validatorAddress}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function getBlanceFromValidator(validator, delegator) {
  try {
    const url = `/v1beta1/validators/${validator}/delegations/${delegator}`;
    const resp = await api$6.get(url);
    return resp?.delegation_response?.balance?.amount;
  } catch (error) {
    return "0";
  }
}
async function getDelegatorTotalClaim(params, host) {
  try {
    const url = `${host}/delegatorTotalClaim?delegator=${params.delegatorAddress}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function getAllValidators(params, host) {
  try {
    const queryParams = [];
    if (params.status) {
      queryParams.push(`status=${params.status}`);
    }
    if (params.offset) {
      queryParams.push(`offset=${params.offset}`);
    }
    if (params.limit) {
      queryParams.push(`limit=${params.limit}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
    const url = `${host}/validator${queryString}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function getRedelegate(delegator, srcAddress) {
  try {
    const resp = await await api$6.get(
      `/v1beta1/delegators/${delegator}/redelegations`
    );
    const dstList = resp?.redelegation_responses?.filter?.(
      (rr) => rr.redelegation?.validator_dst_address === srcAddress
    );
    if (dstList.length > 0) {
      const time = dayjs(
        dstList?.[0]?.entries?.[0]?.redelegation_entry?.completion_time || 0
      ).format("YYYY/MM/DD HH:mm");
      return time;
    } else {
      return "";
    }
  } catch (error) {
    console.error("getRedelegate >>", error);
    return "";
  }
}
async function validatorAlive(validator, host) {
  try {
    const url = `${host}/validatorAlive?validator=${validator}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function setValidatorContact(params, host) {
  try {
    const url = `${host}/setValidatorContact`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    }).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}
async function getValidatorContact(validator, host) {
  try {
    const url = `${host}/getValidatorContact?validator=${validator}`;
    const resp = await fetch(url).then((resp2) => resp2.json());
    return resp;
  } catch (error) {
    return error;
  }
}

var BondStatus = /* @__PURE__ */ ((BondStatus2) => {
  BondStatus2[BondStatus2["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
  BondStatus2[BondStatus2["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
  BondStatus2[BondStatus2["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
  BondStatus2[BondStatus2["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
  BondStatus2[BondStatus2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return BondStatus2;
})(BondStatus || {});

function calculatePercent(part, total) {
  if (!part || !total || +total === 0) return "0";
  const percent = new Big(part).div(new Big(total)).round(6, 2);
  return percent.toString();
}
function bondStatusFromJSON(object) {
  switch (object) {
    case 0:
    case "BOND_STATUS_UNSPECIFIED":
      return BondStatus.BOND_STATUS_UNSPECIFIED;
    case 1:
    case "BOND_STATUS_UNBONDED":
      return BondStatus.BOND_STATUS_UNBONDED;
    case 2:
    case "BOND_STATUS_UNBONDING":
      return BondStatus.BOND_STATUS_UNBONDING;
    case 3:
    case "BOND_STATUS_BONDED":
      return BondStatus.BOND_STATUS_BONDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BondStatus.UNRECOGNIZED;
  }
}

var __defProp$5 = Object.defineProperty;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$5 = (obj, key, value) => __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
class CosmosClient {
  constructor() {
  }
}
__publicField$5(CosmosClient, "decimals", 18);
__publicField$5(CosmosClient, "DELEGATOR_PREFIX", "mtt");
__publicField$5(CosmosClient, "RPC", "https://cosmos-rpc.mtt.network");
__publicField$5(CosmosClient, "REST", "https://cosmos-rest.mtt.network");
__publicField$5(CosmosClient, "denom", "amtt");
__publicField$5(CosmosClient, "chainID", 6880);
__publicField$5(CosmosClient, "cosmosChainId", "mtt_6880-1");

const api$5 = scopeApi("cosmos/bank");
async function getBankSupply() {
  try {
    const resp = await api$5.get("/v1beta1/supply");
    const totalSupply = resp.supply.find((coin) => coin.denom === CosmosClient.denom);
    if (!totalSupply) {
      console.error("Total supply not found!");
      return "0";
    }
    return totalSupply.amount;
  } catch (error) {
    console.error("getBankSupply >>", error);
    return "0";
  }
}

const api$4 = scopeApi("cosmos/base");
async function getBlockLatest() {
  try {
    const latestBlock = await api$4.get("/tendermint/v1beta1/blocks/latest");
    return new SuccessResult({
      blockHeight: latestBlock?.block?.header?.height,
      blockTime: latestBlock?.block?.header?.time
    });
  } catch (error) {
    return new FailureResult(error);
  }
}
async function getBlockAvgTime() {
  const url = "https://explorer.mtt.network/api/v2/stats";
  const stats = await fetch(url).then((resp) => resp.json());
  return {
    average_block_time: stats?.average_block_time || 0,
    gas_prices_slow: stats?.gas_prices?.slow || 0,
    gas_prices_average: stats?.gas_prices?.average || 0,
    gas_prices_fast: stats?.gas_prices?.fast || 0
  };
}

async function processStakingData(params) {
  try {
    const resp = await getStakingsValidators(params);
    const total = await getStakingPoolValidator();
    const delegatorsPromises = resp?.list?.map?.(async (item) => {
      item.displayTokens = (Number(item.tokens) / Math.pow(10, 18)).toString();
      const getDelegatorsParams = {
        validatorAddress: item.operator_address
      };
      try {
        const delegators = await getDelegation(getDelegatorsParams);
        item.delegators = delegators.delegation_responses;
        item.totalDelegations = delegators.pagination.total;
      } catch (error) {
        console.error(
          "Failed to fetch delegators for validator",
          item.operator_address,
          error
        );
        item.delegators = [];
      }
      const displayRate = Number(item?.commission?.commission_rates.rate) / Math.pow(10, 18);
      item.commission.commission_rates.displayRate = displayRate.toString();
      const votingWeight = Number(item.tokens) / Number(total?.totalStaked);
      item.votingWeight = votingWeight;
      const apy = Number(total?.totalRewards) * votingWeight * (1 - Number(item?.commission?.commission_rates?.rate)) / Number(item?.tokens);
      item.apy = apy;
    });
    await Promise.all(delegatorsPromises);
    return resp;
  } catch (error) {
    console.error("Error in processStakingData:", error);
  }
}
async function transformListData(params, host) {
  try {
    const data = await getAllValidators(params, host);
    const total = await getStakingPoolValidator();
    data.data.items.forEach((item) => {
      const apy = Number(total.totalRewards) * (1 - Number(item.commission)) / (Number(total.totalStaked) || 1);
      set(item, "apy", apy);
    });
    return data;
  } catch (error) {
  }
}

var __defProp$4 = Object.defineProperty;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$4 = (obj, key, value) => __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
class VirtualMine {
  constructor(backendHost) {
    /** 区块高度 */
    __publicField$4(this, "blockHeight", "0");
    /** 出块平均时间 */
    __publicField$4(this, "blockAvgTime", 0);
    __publicField$4(this, "backendHost");
    this.backendHost = backendHost;
  }
  /** 获取当前最新区块 */
  getBlockLatest() {
    this.blockHeight = "0";
    return new Promise(async (resolve, reject) => {
      const latest = await getBlockLatest();
      if (latest?.isSuccess) {
        this.blockHeight = latest?.data?.blockHeight || "0";
        return resolve(new SuccessResult(this.blockHeight));
      } else {
        return reject(latest);
      }
    });
  }
  /** 获取stats数据 */
  getStats() {
    return new Promise(async (resolve) => {
      const resp = await getBlockAvgTime();
      this.blockAvgTime = resp?.average_block_time;
      return resolve(new SuccessResult(resp));
    });
  }
  /** 获取质押占比 */
  async getTotalStacked() {
    const supply = await getBankSupply();
    const pool = await getStakingPool();
    const stakedPercentage = +calculatePercent(pool.bondedTokens, supply) * 100;
    console.log(`Total Supply: ${supply}`);
    console.log(`Total Staked: ${pool.bondedTokens}`);
    console.log(`Staked Percentage: ${stakedPercentage}`);
    return stakedPercentage.toString();
  }
  /** 获取平均年化收益 */
  async getAvgApy() {
    const resp = await getStakingPoolValidator();
    const avgApy = +calculatePercent(resp.totalRewards, resp.totalStaked) * 100;
    console.log(`avg.APY: ${avgApy}`);
    return avgApy.toString();
  }
  async getDelegators(params) {
    return new Promise(async (resolve, reject) => {
      const resp = await getDelegation(params);
      return resolve(resp);
    });
  }
  async getStakingList(params) {
    try {
      const resp = await processStakingData(params);
      console.log("getStakingList >>", resp);
      return new SuccessResult(resp);
    } catch (error) {
      console.error("Error in getStakingList:", error);
      throw error;
    }
  }
  /** 获取验证者 */
  async getValidators() {
    const alltime = await getStakingAlltimeVlidator();
    const active = alltime.filter(
      (validator) => bondStatusFromJSON(validator.status) === BondStatus.BOND_STATUS_BONDED
    );
    console.log("getValidators", alltime.length, active.length);
    return { alltime, active };
  }
  async getValidatorList(params) {
    try {
      const data = await transformListData(params, this.backendHost);
      return data;
    } catch (error) {
      throw error;
    }
  }
}

const MSG_CANCEL_UNBONDING_DELEGATION_TYPES = {
  MsgValue: [
    { name: "delegator_address", type: "string" },
    { name: "validator_address", type: "string" },
    { name: "amount", type: "TypeAmount" },
    { name: "creation_height", type: "int64" }
  ],
  TypeAmount: [
    { name: "denom", type: "string" },
    { name: "amount", type: "string" }
  ]
};
function createMsgCancelUnbondingDelegation(delegatorAddress, validatorAddress, amount, denom, creationHeight) {
  return {
    type: "cosmos-sdk/MsgCancelUnbondingDelegation",
    value: {
      delegator_address: delegatorAddress,
      validator_address: validatorAddress,
      amount: {
        amount,
        denom
      },
      creation_height: creationHeight
    }
  };
}
const createEIP712MsgCancelUnbondingDelegation = (params) => {
  const types = {
    EIP712Domain: [
      { name: "name", type: "string" },
      { name: "version", type: "string" },
      { name: "chainId", type: "uint256" },
      { name: "verifyingContract", type: "string" },
      { name: "salt", type: "string" }
    ],
    Tx: [
      { name: "account_number", type: "string" },
      { name: "chain_id", type: "string" },
      { name: "fee", type: "Fee" },
      { name: "memo", type: "string" },
      { name: "msgs", type: "Msg[]" },
      { name: "sequence", type: "string" }
    ],
    Fee: [
      { name: "feePayer", type: "string" },
      { name: "amount", type: "Coin[]" },
      { name: "gas", type: "string" }
    ],
    Coin: [
      { name: "denom", type: "string" },
      { name: "amount", type: "string" }
    ],
    Msg: [
      { name: "type", type: "string" },
      { name: "value", type: "MsgValue" }
    ],
    ...MSG_CANCEL_UNBONDING_DELEGATION_TYPES
  };
  const message = createMsgCancelUnbondingDelegation(
    params.delegatorAddress,
    params.validatorAddress,
    params.amount,
    params.denom,
    params.creationHeight
  );
  return {
    types,
    message
  };
};
const createCosmosMsgCancelUnbondingDelegation = (params) => {
  return protoMsgCancelUnbondingDelegation(
    params.delegatorAddress,
    params.validatorAddress,
    params.amount,
    params.denom,
    params.creationHeight
  );
};
function protoMsgCancelUnbondingDelegation(delegatorAddress, validatorAddress, amount, denom, creationHeight) {
  const value = new coin__default.cosmos.base.v1beta1.Coin({
    denom,
    amount
  });
  const message = new MsgTxCancelUnbondingDelegation({
    delegator_address: delegatorAddress,
    validator_address: validatorAddress,
    amount: value,
    creation_height: creationHeight
  });
  return {
    message,
    path: "cosmos.staking.v1beta1.MsgCancelUnbondingDelegation"
  };
}
const createTxMsgCancelUnbondingDelegation = (context, params) => {
  const typedData = createEIP712MsgCancelUnbondingDelegation(params);
  const cosmosMsg = createCosmosMsgCancelUnbondingDelegation(params);
  return createTransactionPayload(context, typedData, [cosmosMsg]);
};
const wrapTypeToArray = (obj) => {
  return Array.isArray(obj) ? obj : [obj];
};
const createLegacyEIP712Payload = (context, typedData) => {
  const { fee, sender, chain, memo } = context;
  const feeObject = eip712_1.generateFee(
    fee.amount,
    fee.denom,
    fee.gas,
    sender.accountAddress
  );
  const payloadMessages = wrapTypeToArray(typedData.message);
  const messages = eip712_1.generateMessageWithMultipleTransactions(
    sender.accountNumber.toString(),
    sender.sequence.toString(),
    chain.cosmosChainId,
    memo,
    feeObject,
    payloadMessages
  );
  return eip712_1.createEIP712(typedData.types, chain.chainId, messages);
};
const createCosmosPayload = (context, cosmosPayload) => {
  const { fee, sender, chain, memo } = context;
  const messages = wrapTypeToArray(cosmosPayload);
  return createTransactionWithMultipleMessages(
    messages,
    memo,
    fee.amount,
    fee.denom,
    parseInt(fee.gas, 10),
    "ethsecp256",
    sender.pubkey,
    sender.sequence,
    sender.accountNumber,
    chain.cosmosChainId
  );
};
const createTransactionPayload = (context, typedData, cosmosMessage) => {
  const eip712Payload = createLegacyEIP712Payload(context, typedData);
  const cosmosPayload = createCosmosPayload(context, cosmosMessage);
  return {
    signDirect: cosmosPayload.signDirect,
    legacyAmino: cosmosPayload.legacyAmino,
    eipToSign: eip712Payload
  };
};
class MsgTxCancelUnbondingDelegation extends pb_1.Message {
  constructor(data) {
    super();
    pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
    if (!Array.isArray(data) && typeof data == "object") {
      if ("delegator_address" in data && data.delegator_address != void 0) {
        this.delegator_address = data.delegator_address;
      }
      if ("validator_address" in data && data.validator_address != void 0) {
        this.validator_address = data.validator_address;
      }
      if ("amount" in data && data.amount != void 0) {
        this.amount = data.amount;
      }
      if ("creation_height" in data && data.creation_height != void 0) {
        this.creation_height = data.creation_height;
      }
    }
  }
  get delegator_address() {
    return pb_1.Message.getField(this, 1);
  }
  set delegator_address(value) {
    pb_1.Message.setField(this, 1, value);
  }
  get validator_address() {
    return pb_1.Message.getField(this, 2);
  }
  set validator_address(value) {
    pb_1.Message.setField(this, 2, value);
  }
  get amount() {
    return pb_1.Message.getWrapperField(this, coin__default.cosmos.base.v1beta1.Coin, 3);
  }
  set amount(value) {
    pb_1.Message.setWrapperField(this, 3, value);
  }
  get creation_height() {
    return pb_1.Message.getField(this, 4);
  }
  set creation_height(value) {
    pb_1.Message.setField(this, 4, value);
  }
  static fromObject(data) {
    const message = new MsgTxCancelUnbondingDelegation({});
    if (data.delegator_address != null) {
      message.delegator_address = data.delegator_address;
    }
    if (data.validator_address != null) {
      message.validator_address = data.validator_address;
    }
    if (data.amount != null) {
      message.amount = coin__default.cosmos.base.v1beta1.Coin.fromObject(data.amount);
    }
    if (data.creation_height != null) {
      message.creation_height = data.creation_height;
    }
    return message;
  }
  toObject() {
    const data = {};
    if (this.delegator_address != null) {
      data.delegator_address = this.delegator_address;
    }
    if (this.validator_address != null) {
      data.validator_address = this.validator_address;
    }
    if (this.amount != null) {
      data.amount = this.amount.toObject();
    }
    if (this.creation_height != null) {
      data.creation_height = this.creation_height;
    }
    return data;
  }
  serialize(w) {
    const writer = w || new pb_1.BinaryWriter();
    if (typeof this.delegator_address === "string" && this.delegator_address.length)
      writer.writeString(1, this.delegator_address);
    if (typeof this.validator_address === "string" && this.validator_address.length)
      writer.writeString(2, this.validator_address);
    if (this.amount !== void 0)
      writer.writeMessage(3, this.amount, () => this.amount.serialize(writer));
    if (typeof this.creation_height === "number" && this.creation_height > 0) {
      writer.writeInt64(4, this.creation_height);
    }
    if (!w)
      return writer.getResultBuffer();
  }
  static deserialize(bytes) {
    const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MsgTxCancelUnbondingDelegation({});
    while (reader.nextField()) {
      if (reader.isEndGroup())
        break;
      switch (reader.getFieldNumber()) {
        case 1:
          message.delegator_address = reader.readString();
          break;
        case 2:
          message.validator_address = reader.readString();
          break;
        case 3:
          reader.readMessage(message.amount, () => message.amount = coin__default.cosmos.base.v1beta1.Coin.deserialize(reader));
          break;
        case 4:
          message.creation_height = reader.readInt64();
          break;
        default:
          reader.skipField();
      }
    }
    return message;
  }
  serializeBinary() {
    return this.serialize();
  }
  static deserializeBinary(bytes) {
    return MsgTxCancelUnbondingDelegation.deserialize(bytes);
  }
}

const api$3 = scopeApi("cosmos/auth");
async function getAccountByAddress(address) {
  try {
    const account = await api$3.get(`/v1beta1/accounts/${address}`);
    return new SuccessResult(account?.account);
  } catch (error) {
    return new FailureResult(error);
  }
}

const api$2 = scopeApi("cosmos/tx");
async function getTxByHash(txHash) {
  try {
    const tx = await api$2.get(`/v1beta1/txs/${txHash}`);
    return tx;
  } catch (error) {
    console.error("getTxByHash >>>", error);
    return null;
  }
}
async function checkTxHash(txHash) {
  if (!txHash) return Promise.reject(new FailureResult(false));
  return new Promise(async (resolve, reject) => {
    let count = 0;
    while (true) {
      try {
        count++;
        const resp = await getTxByHash(txHash);
        const isOk = resp?.tx_response?.code === 0;
        console.log(`[txHash]: ${desensitizeHash(txHash)}, [Count]: ${count}, [is Ok]: ${isOk}`);
        if (resp) {
          if (isOk) {
            return resolve(new SuccessResult(resp?.tx_response));
          } else {
            return reject(resp?.tx_response);
          }
        }
        await new Promise((rv) => {
          setTimeout(() => rv(1), 2e3);
        });
        if (count >= 50) {
          return reject(new BaseResult(WalletCode.INTERNAL_TIMEOUT));
        }
      } catch (error) {
        reject(new FailureResult(error));
        break;
      }
    }
  });
}
async function txSimulate(req) {
  try {
    const simulate = await api$2.post("/v1beta1/simulate", req);
    return new SuccessResult(simulate?.gas_info?.gas_used);
  } catch (error) {
    console.error("txSimulate >>", error);
    const isLockByRedelegate = error?.message?.includes?.("redelegation to this validator already in progress");
    if (isLockByRedelegate) {
      return new BaseResult(WalletCode.INTERNAL_REDELEGATE_7);
    }
    return new BaseResult(WalletCode.INTERNAL_INSUFFICIENT_GAS);
  }
}

function makeBech32Encoder(prefix) {
  return (data) => bech32.encode(prefix, bech32.toWords(data));
}
function makeBech32Decoder(currentPrefix) {
  return (data) => {
    const { prefix, words } = bech32.decode(data);
    console.log("makeBech32Decoder >>", prefix, currentPrefix);
    if (prefix !== currentPrefix) {
      throw Error("Unrecognised address format");
    }
    return Buffer$1.from(bech32.fromWords(words));
  };
}
const bech32Chain = (name, prefix) => ({
  decoder: makeBech32Decoder(prefix),
  encoder: makeBech32Encoder(prefix),
  name
});
function makeChecksummedHexDecoder(chainId) {
  return (data) => {
    const stripped = stripHexPrefix(data);
    if (!isValidChecksumAddress(data, null) && stripped !== stripped.toLowerCase() && stripped !== stripped.toUpperCase()) {
      throw Error("Invalid address checksum");
    }
    return Buffer$1.from(stripHexPrefix(data), "hex");
  };
}
function makeChecksummedHexEncoder(chainId) {
  return (data) => toChecksumAddress(data.toString("hex"), null);
}
const hexChecksumChain = (name, chainId) => ({
  decoder: makeChecksummedHexDecoder(),
  encoder: makeChecksummedHexEncoder(),
  name
});
const EVMOS = bech32Chain("MTT", "mtt");
const ETH = hexChecksumChain("ETH");
const evmosToEth = (evmosAddress) => {
  const data = EVMOS.decoder(evmosAddress);
  return ETH.encoder(data);
};

function evmToCosmos(evmAddress) {
  if (!/^0x[0-9a-fA-F]{40}$/.test(evmAddress)) {
    throw new Error("Invalid EVM address");
  }
  const hex = evmAddress.slice(2);
  const bytes = Buffer$1.from(hex, "hex");
  const prefix = "mtt";
  const words = bech32.toWords(bytes);
  return bech32.encode(prefix, words);
}
function cosmosToEvm(cosmosAddress) {
  if (!cosmosAddress.startsWith("mtt")) {
    throw new Error("Invalid Cosmos address prefix");
  }
  const { words } = bech32.decode(cosmosAddress);
  const bytes = bech32.fromWords(words);
  if (bytes.length !== 20) {
    throw new Error("Invalid Cosmos address length");
  }
  const evmAddress = "0x" + bytes.map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return evmAddress;
}
function mttToValoper(mttAddress) {
  if (!mttAddress.startsWith("mtt")) {
    throw new Error("Invalid Cosmos address prefix");
  }
  const prefix = "mttvaloper";
  const decoded = bech32.decode(mttAddress);
  const validatorAddress = bech32.encode(prefix, decoded.words);
  return validatorAddress;
}
function mttToValoperV2(evmAddress) {
  if (!/^0x[0-9a-fA-F]{40}$/.test(evmAddress)) {
    throw new Error("Invalid EVM address");
  }
  const hex = evmAddress.slice(2);
  const bytes = Buffer$1.from(hex, "hex");
  const prefix = "mttvaloper";
  const words = bech32.toWords(bytes);
  return bech32.encode(prefix, words);
}

async function globalStaking(actionFn) {
  try {
    if (window.ethereum) {
      const addressResp = await getAddress();
      if (!addressResp.isSuccess) {
        return addressResp;
      }
      const { evmAddress, accountAddress } = addressResp?.data;
      console.log("evmAddress >>>", evmAddress);
      console.log("accountAddress >>>", accountAddress);
      const publicKeyResp = await getPublicKey(accountAddress, evmAddress);
      if (!publicKeyResp) {
        return new FailureResult(null, "\u65E0\u6CD5\u63D0\u53D6\u516C\u94A5");
      }
      console.log("publicKey >>>", publicKeyResp);
      const tx = await actionFn(accountAddress, publicKeyResp);
      console.log("actionFn >>>>>>>>>>>>", tx);
      if (!tx?.isSuccess) {
        return tx;
      }
      const signedTx = await getSignedTx(accountAddress, tx?.data);
      console.log("signedTx >>>", signedTx);
      const broadcastResp = await getBroadcast(signedTx);
      console.log("broadcastPost >>>>", broadcastResp);
      if (broadcastResp?.tx_response?.code === 0) {
        const txHashResp = await checkTxHash(broadcastResp?.tx_response?.txhash);
        return txHashResp;
      } else {
        return new BaseResult(broadcastResp?.tx_response?.code, broadcastResp?.tx_response?.raw_log);
      }
    } else {
      return new BaseResult(WalletCode.METAMASK_CONNECT_ERR);
    }
  } catch (error) {
    console.error("delegate >>>", error);
    return new FailureResult(error);
  }
}
async function getAddress() {
  console.log("1.\u524D\u7F6E\u9700\u8981\u7684\u6761\u4EF6 >>>");
  try {
    const provider = new BrowserProvider(window.ethereum);
    await provider.send("eth_accounts", []);
    const signer = await provider.getSigner();
    const evmAddress = await signer.getAddress();
    const accountAddress = evmToCosmos(evmAddress);
    return new SuccessResult({ evmAddress, accountAddress });
  } catch (error) {
    return new FailureResult(error);
  }
}
function getTxChain() {
  const chain = {
    chainId: CosmosClient.chainID,
    cosmosChainId: CosmosClient.cosmosChainId
  };
  return chain;
}
async function getTxFee(gasLimit = "230000") {
  const fee = {
    amount: "22000000000000000",
    denom: CosmosClient.denom,
    gas: gasLimit
  };
  return fee;
}
function getTxSender(accountAddress, publicKeyResp) {
  const sender = {
    accountAddress,
    sequence: publicKeyResp?.sequence,
    accountNumber: publicKeyResp?.accountNumber,
    // Use the public key from the account query, or retrieve
    // the public key from the code snippet above.
    pubkey: publicKeyResp?.publicKey
    //base64
  };
  return sender;
}
async function getSignedTx(accountAddress, tx) {
  const senderHexAddress = evmosToEth(accountAddress);
  const eip712Payload = JSON.stringify(tx.eipToSign);
  console.log("senderHexAddress >>>", senderHexAddress, eip712Payload);
  const signature_payload = await window.ethereum.request({
    method: "eth_signTypedData_v4",
    params: [senderHexAddress, eip712Payload]
  });
  const signatureBytes = Buffer.from(signature_payload.replace("0x", ""), "hex");
  const bodyBytes = tx.signDirect.body.serialize();
  const authInfoBytes = tx.signDirect.authInfo.serialize();
  const signedTx = createTxRaw(bodyBytes, authInfoBytes, [signatureBytes]);
  return signedTx;
}
async function getBroadcast(signedTx) {
  const postOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: generatePostBodyBroadcast(signedTx)
  };
  const broadcastEndpoint = `${CosmosClient.REST}${generateEndpointBroadcast()}`;
  const broadcastPost = await fetch(broadcastEndpoint, postOptions);
  const response = await broadcastPost.json();
  return response;
}
async function getPublicKey(accountAddress, evmAddress) {
  try {
    const accountResp = await getAccountByAddress(accountAddress);
    if (accountResp?.isSuccess && accountResp?.data?.base_account?.pub_key) {
      return {
        sequence: accountResp?.data?.base_account?.sequence,
        publicKey: accountResp?.data?.base_account?.pub_key?.key,
        accountNumber: accountResp?.data?.base_account?.account_number
      };
    }
    const message = "Verify Public Key";
    const signature = await window?.ethereum?.request({
      method: "personal_sign",
      params: [message, evmAddress, ""]
    });
    const uncompressedPk = recoverPublicKey(hashMessage(message), signature);
    console.log("uncompressedPk", uncompressedPk);
    const hexPk = computePublicKey(uncompressedPk, true);
    const pk = Buffer.from(hexPk.replace("0x", ""), "hex").toString("base64");
    console.log("pk", pk);
    return {
      publicKey: pk,
      sequence: accountResp?.data?.base_account?.sequence,
      accountNumber: accountResp?.data?.base_account?.account_number
    };
  } catch (error) {
    console.error("getPublicKey >>", error);
    return null;
  }
}
async function simulate(tx) {
  const txRaw = new cosmosType.cosmos.tx.v1beta1.TxRaw({
    body_bytes: tx?.signDirect?.body?.serializeBinary?.(),
    auth_info_bytes: tx?.signDirect?.authInfo?.serializeBinary?.(),
    signatures: [new Uint8Array()]
  });
  const txBytes = txRaw.serializeBinary();
  const base64TxBytes = Buffer.from(txBytes).toString("base64");
  const result = await txSimulate({ tx_bytes: base64TxBytes });
  if (!result?.isSuccess) {
    return result;
  }
  const gasUsed = +result?.data ? result?.data : "250000";
  const gasLimit = Math.round(Number(gasUsed) * 1.2).toString();
  console.log("gasLimit >>", gasUsed, gasLimit);
  return new SuccessResult(gasLimit);
}

class MiningStaking {
  constructor() {
  }
  /** 质押 */
  async delegate(value, validatorAddress) {
    if (!value || !+value) return new FailureResult(null, "value 0");
    return await globalStaking(async (accountAddress, publicKeyResp) => {
      const memo = "delegate";
      const oldFee = await getTxFee();
      const chain = getTxChain();
      const sender = getTxSender(accountAddress, publicKeyResp);
      const params = {
        validatorAddress,
        amount: ethers.parseUnits(value.toString(), CosmosClient.decimals).toString(),
        denom: CosmosClient.denom
      };
      const oldTx = createTxMsgDelegate(chain, sender, oldFee, memo, params);
      console.log("oldTx >>>>>>>>>>>>", oldTx);
      const gasLimit = await simulate(oldTx);
      if (!gasLimit?.isSuccess) {
        return gasLimit;
      }
      const fee = await getTxFee(gasLimit?.data);
      console.log(value, chain, sender, fee, memo, params);
      const tx = createTxMsgDelegate(chain, sender, fee, memo, params);
      console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
      return new SuccessResult(tx);
    });
  }
  /** 取消质押 */
  async undelegate(value, validatorAddress) {
    if (!value || !+value) return new FailureResult(null, "value 0");
    return await globalStaking(async (accountAddress, publicKeyResp) => {
      const memo = "undelegate";
      const oldFee = await getTxFee();
      const chain = getTxChain();
      const sender = getTxSender(accountAddress, publicKeyResp);
      const params = {
        validatorAddress,
        amount: ethers.parseUnits(value.toString(), CosmosClient.decimals).toString(),
        denom: CosmosClient.denom
      };
      const oldTx = createTxMsgUndelegate(chain, sender, oldFee, memo, params);
      console.log("oldTx >>>>>>>>>>>>", oldTx);
      const gasLimit = await simulate(oldTx);
      if (!gasLimit?.isSuccess) {
        return gasLimit;
      }
      const fee = await getTxFee(gasLimit?.data);
      console.log(value, chain, sender, fee, memo, params);
      const tx = createTxMsgUndelegate(chain, sender, fee, memo, params);
      console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
      return new SuccessResult(tx);
    });
  }
  /** 获取收益 */
  async withdrawRewards(validatorAddress) {
    if (!validatorAddress || !validatorAddress?.length) return new FailureResult(null, "validatorAddress 0");
    return await globalStaking(async (accountAddress, publicKeyResp) => {
      const memo = "withdrawRewards";
      const oldFee = await getTxFee();
      const chain = getTxChain();
      const sender = getTxSender(accountAddress, publicKeyResp);
      const params = {
        validatorAddresses: validatorAddress
      };
      const oldTx = createTxMsgMultipleWithdrawDelegatorReward(chain, sender, oldFee, memo, params);
      console.log("oldTx >>>>>>>>>>>>", oldTx);
      const gasLimit = await simulate(oldTx);
      if (!gasLimit?.isSuccess) {
        return gasLimit;
      }
      const fee = await getTxFee(gasLimit?.data);
      console.log(chain, sender, fee, memo, params);
      const tx = createTxMsgMultipleWithdrawDelegatorReward(chain, sender, fee, memo, params);
      console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
      return new SuccessResult(tx);
    });
  }
  /** 更换质押 */
  async redelegate(value, srcAddress, dstAddress) {
    if (!value || !+value) return new FailureResult(null, "value 0");
    return await globalStaking(async (accountAddress, publicKeyResp) => {
      const memo = "redelegate";
      const oldFee = await getTxFee();
      const chain = getTxChain();
      const sender = getTxSender(accountAddress, publicKeyResp);
      const params = {
        validatorSrcAddress: srcAddress,
        validatorDstAddress: dstAddress,
        amount: ethers.parseUnits(value.toString(), CosmosClient.decimals).toString(),
        denom: CosmosClient.denom
      };
      const oldTx = createTxMsgBeginRedelegate(chain, sender, oldFee, memo, params);
      console.log("oldTx >>>>>>>>>>>>", oldTx);
      const gasLimit = await simulate(oldTx);
      if (!gasLimit?.isSuccess) {
        const time = await getRedelegate(accountAddress, srcAddress);
        const message = gasLimit?.msg?.replace(/{time}/, time);
        return new BaseResult(gasLimit?.code, gasLimit?.data, message);
      }
      const fee = await getTxFee(gasLimit?.data);
      console.log(value, chain, sender, fee, memo, params);
      const tx = createTxMsgBeginRedelegate(chain, sender, fee, memo, params);
      console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
      return new SuccessResult(tx);
    });
  }
  /** 取消解质押 */
  async cancelUnbondingDelegate(value, validatorAddress, delegatorAddress, creationHeight) {
    if (!value || !+value) return new FailureResult(null, "value 0");
    return await globalStaking(async (accountAddress, publicKeyResp) => {
      const memo = "cancelUnbondingDelegate";
      const oldFee = await getTxFee();
      const chain = getTxChain();
      const sender = getTxSender(accountAddress, publicKeyResp);
      const params = {
        delegatorAddress,
        validatorAddress,
        amount: ethers.parseUnits(value, CosmosClient.decimals).toString(),
        denom: CosmosClient.denom,
        creationHeight
      };
      const oldTx = createTxMsgCancelUnbondingDelegation({ chain, sender, fee: oldFee, memo }, params);
      console.log("oldTx >>>>>>>>>>>>", oldTx);
      const gasLimit = await simulate(oldTx);
      if (!gasLimit?.isSuccess) {
        return gasLimit;
      }
      const fee = await getTxFee(gasLimit?.data);
      console.log(value, chain, sender, fee, memo, params);
      const tx = createTxMsgCancelUnbondingDelegation({ chain, sender, fee, memo }, params);
      console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
      return new SuccessResult(tx);
    });
  }
  /** 信息录入 */
  async enterUserInfo(validator, email, tg, timestamp) {
    try {
      const provider = new BrowserProvider(window.ethereum);
      await provider.send("eth_accounts", []);
      const signer = await provider.getSigner();
      const evmAddress = await signer.getAddress();
      const message = `${validator}-${tg}-${email}-${timestamp}`;
      const signature = await window?.ethereum?.request({
        method: "personal_sign",
        params: [message, evmAddress, ""]
      });
      return new SuccessResult({
        validator,
        tg,
        email,
        timestamp,
        sig: signature
      });
    } catch (error) {
      return new FailureResult(error);
    }
  }
}

var WalletEmitEnum = /* @__PURE__ */ ((WalletEmitEnum2) => {
  WalletEmitEnum2["WALLET_MINING_BLOCK"] = "wallet:mining:block";
  return WalletEmitEnum2;
})(WalletEmitEnum || {});

var __defProp$3 = Object.defineProperty;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$3 = (obj, key, value) => __defNormalProp$3(obj, typeof key !== "symbol" ? key + "" : key, value);
class BaseEmitter {
  constructor(emitSignal) {
    /** 事件 */
    __publicField$3(this, "eventEmitter", mitt());
    /** 配置监听的类型 */
    __publicField$3(this, "emitSignal");
    this.emitSignal = emitSignal;
  }
  onEmitter(func) {
    this.eventEmitter.on(this.emitSignal, func);
  }
  offEmitter(func) {
    this.eventEmitter.off(this.emitSignal, func);
  }
  emitEmitter(result) {
    this.eventEmitter.emit(this.emitSignal, result);
  }
}

var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
class WebSocketMiningBlock extends BaseEmitter {
  constructor(url) {
    super(WalletEmitEnum.WALLET_MINING_BLOCK);
    __publicField$2(this, "url", "");
    __publicField$2(this, "ws", null);
    __publicField$2(this, "isConnected", false);
    /** 配置监听的类型 */
    __publicField$2(this, "emitSignal", WalletEmitEnum.WALLET_MINING_BLOCK);
    this.url = url;
    this.ws = null;
    this.isConnected = false;
  }
  // 连接 WebSocket 并初始化事件
  connect() {
    if (this.ws) {
      console.warn("WebSocket is already connected.");
      return;
    }
    this.ws = new WebSocket(this.url);
    this.ws.onopen = () => {
      this.isConnected = true;
      console.log("WebSocket connected.");
      this.ws.send(
        JSON.stringify({
          jsonrpc: "2.0",
          method: "subscribe",
          id: 1,
          params: ["tm.event='NewBlock'"]
        })
      );
    };
    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.result) {
        const eventType = data.result.query;
        if (eventType === "tm.event='NewBlock'") {
          const blockHeight = data.result?.data?.value?.block?.header?.height || "0";
          this.emitEmitter(new SuccessResult(blockHeight));
        }
      }
    };
    this.ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      this.emitEmitter(new FailureResult(""));
    };
    this.ws.onclose = (event) => {
      console.log("WebSocket closed:", event.reason);
      this.emitEmitter(new FailureResult(""));
      this.isConnected = false;
      this.ws = null;
    };
  }
  // 断开 WebSocket 连接
  disconnect() {
    if (this.ws) {
      console.log("Closing WebSocket...");
      this.ws.close(1e3, "Client closed the connection.");
      this.ws = null;
      this.isConnected = false;
    } else {
      console.warn("WebSocket is not connected.");
    }
  }
}

const api$1 = scopeApi("cosmos/distribution");
async function getDelegatorReward(params) {
  try {
    const resp = await api$1.get(
      `/v1beta1/delegators/${params.delegatorAddress}/rewards/${params.validatorAddress} `
    );
    return resp.rewards;
  } catch (error) {
    return error;
  }
}

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => __defNormalProp$1(obj, key + "" , value);
class VirtualDetail {
  constructor(backendHost) {
    __publicField$1(this, "backendHost");
    this.backendHost = backendHost;
  }
  async getDelegators(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await getDelegation(params);
        if (resp.code === -1) {
          return reject(new FailureResult());
        }
        return resolve(new SuccessResult(resp));
      } catch (error) {
        return reject(new FailureResult(error));
      }
    });
  }
  async getValidatorDetail(params) {
    const total = await getStakingPoolValidator();
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await getValidator(params);
        if (resp.code === -1) {
          return reject(new FailureResult());
        }
        const votingWeight = Number(resp.tokens) / Number(total.totalStaked);
        const apy = Number(total.totalRewards) * votingWeight * (1 - Number(resp?.commission?.commission_rates.rate)) / Number(resp.tokens);
        Object.assign(resp, { votingWeight, apy });
        return resolve(new SuccessResult(resp));
      } catch (error) {
        return reject(new FailureResult());
      }
    });
  }
  async getNodeDetail(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const delegatorData = await this.getDelegators(params);
        const detailData = await this.getValidatorDetail(params);
        return resolve(
          new SuccessResult({
            delegator: delegatorData.data.delegation_responses,
            detail: detailData.data
          })
        );
      } catch (error) {
        console.error(error, "error");
        return reject(new FailureResult(error));
      }
    });
  }
  async getSelfStakeInfos(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await getSelfStakeInfo(params);
        return resolve(new SuccessResult(resp));
      } catch (error) {
        return reject(new FailureResult(error));
      }
    });
  }
  async getSelfDelegaterList(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await getMineDelegatorList(params);
        const delegationResponses = resp.delegation_responses;
        const targetData = {
          delegator: params.delegatorAddress,
          validators: delegationResponses.map(
            (item) => item.delegation.validator_address
          ),
          amounts: delegationResponses.map(
            (item) => item.balance.amount || "0"
          ),
          denom: delegationResponses[0]?.balance?.denom || ""
        };
        return resolve(new SuccessResult(targetData));
      } catch (error) {
        return reject(new FailureResult(error));
      }
    });
  }
  async getDelegatorRewardInfo(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await getDelegatorReward(params);
        return resolve(new SuccessResult(resp));
      } catch (error) {
        return reject(new FailureResult(error));
      }
    });
  }
  async getRewardHistory(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const stakeHistory = await getStakeHistoryRecord(
          params,
          this.backendHost
        );
        return resolve(stakeHistory);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async getValidatorHistory(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getValidatorRecord(params, this.backendHost);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async getDelegatorHistory(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getDelegatorRecord(params, this.backendHost);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async getTxDetail(txHash) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getTxByHash(txHash);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async getTotalClaim(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getDelegatorTotalClaim(params, this.backendHost);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async getValidatorAlive(validator) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await validatorAlive(validator, this.backendHost);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async getValidatorContactInfo(validators) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getValidatorContact(validators, this.backendHost);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  async setValidatorContactInfo(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await setValidatorContact(params, this.backendHost);
        return resolve(data);
      } catch (error) {
        return reject(error);
      }
    });
  }
}

var rpc = "https://cosmos-rpc.mtt.network/";
var rest = "https://cosmos-rest.mtt.network/";
var chainId = "mtt_6880-1";
var evmId = "6880";
var chainName = "MTT Mainnet";
var stakeCurrency = {
	coinDenom: "MTT",
	coinMinimalDenom: "amtt",
	coinDecimals: 18
};
var bech32Config = {
	bech32PrefixAccAddr: "mtt",
	bech32PrefixAccPub: "mttpub",
	bech32PrefixValAddr: "mttvaloper",
	bech32PrefixValPub: "mttvaloperpub",
	bech32PrefixConsAddr: "mttvalcons",
	bech32PrefixConsPub: "mttvalconspub"
};
var bip44 = {
	coinType: 60
};
var currencies = [
	{
		coinDenom: "MTT",
		coinMinimalDenom: "amtt",
		coinDecimals: 18,
		coinImageUrl: "https://266-mtt.oss-ap-southeast-1.aliyuncs.com/mid/erc20-token/voXVC1hp.png"
	}
];
var feeCurrencies = [
	{
		coinDenom: "MTT",
		coinMinimalDenom: "amtt",
		coinDecimals: 18,
		coinImageUrl: "https://266-mtt.oss-ap-southeast-1.aliyuncs.com/mid/erc20-token/voXVC1hp.png",
		gasPriceStep: {
			low: 10000000000,
			average: 15000000000,
			high: 20000000000
		}
	}
];
var features = [
	"ibc-transfer",
	"ibc-go",
	"eth-address-gen",
	"eth-key-sign"
];
var chainSymbolImageUrl = "https://266-mtt.oss-ap-southeast-1.aliyuncs.com/mid/erc20-token/voXVC1hp.png";
var mttCosmosJson = {
	rpc: rpc,
	rest: rest,
	chainId: chainId,
	evmId: evmId,
	chainName: chainName,
	stakeCurrency: stakeCurrency,
	bech32Config: bech32Config,
	bip44: bip44,
	currencies: currencies,
	feeCurrencies: feeCurrencies,
	features: features,
	chainSymbolImageUrl: chainSymbolImageUrl
};

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class WalletKeplr {
  constructor(scope) {
    __publicField(this, "scope", "auto_keplr");
    __publicField(this, "_keplr", null);
    /** 是否手机设备 */
    __publicField(this, "isMobile", false);
    /** 是否支持插件 */
    __publicField(this, "isSupport", false);
    /** 是否已经安装插件 */
    __publicField(this, "isInstall", false);
    /** 钱包地址 */
    __publicField(this, "address", "");
    this.scope = scope;
  }
  /** 检查是否支持插件 */
  isSupportPlugin() {
    if (this.isMobile) return false;
    const btype = deviceDetect(navigator.userAgent).browserName || navigator.userAgent;
    return btype.includes("Chrome") || btype.includes("Edge") || btype.includes("Firefox");
  }
  /** 检查是否安装插件 */
  isInstallPlugin() {
    if (this.isMobile) return false;
    return typeof window.keplr !== "undefined";
  }
  // 初始化检查
  initKeplr(init) {
    this.isMobile = init.isMobile;
    return new Promise(async (resolve, reject) => {
      if (this.isMobile) {
        return reject(new BaseResult(WalletCode.METAMASK_NOT_DEVICE, null, walletCodeMessage[WalletCode.METAMASK_NOT_DEVICE]));
      }
      this.isSupport = this.isSupportPlugin();
      if (!this.isSupport) {
        return reject(new BaseResult(WalletCode.METAMASK_NOT_PLUGIN, null, walletCodeMessage[WalletCode.METAMASK_NOT_PLUGIN]));
      }
      this.isInstall = this.isInstallPlugin();
      if (!this.isInstall) {
        return reject(new BaseResult(WalletCode.METAMASK_NOT_INSTALL, null, walletCodeMessage[WalletCode.METAMASK_NOT_INSTALL]));
      }
      this._keplr = await Keplr.getKeplr();
      return resolve(new SuccessResult(this._keplr));
    });
  }
  // 检查keplr实例
  async checkKeplr() {
    if (!this._keplr) {
      this._keplr = await Keplr.getKeplr();
    }
    return this._keplr;
  }
  // 连接请求
  async connectKeplr() {
    await this.checkKeplr();
    try {
      const chainId = "osmosis-1";
      const resp = await this._keplr.getChainInfoWithoutEndpoints(chainId);
      await this._keplr.enable(chainId);
      const offlineSigner = this._keplr.getOfflineSigner(chainId);
      const accounts = await offlineSigner.getAccounts();
      this.address = accounts[0].address;
      return new SuccessResult(this.address);
    } catch (error) {
      return new BaseResult(WalletCode.METAMASK_CONNECT_ERR, null, walletCodeMessage[WalletCode.METAMASK_CONNECT_ERR]);
    }
  }
  // 断开连接
  async disconnectKeplr() {
    await this.checkKeplr();
    try {
      const chainId = "osmosis-1";
      await this._keplr.disable(chainId);
      this.address = "";
      return new SuccessResult(true);
    } catch (error) {
      return new FailureResult(false);
    }
  }
  // 获取余额
  /**
   * https://lcd.osmosis.zone/cosmos/bank/v1beta1/balances/osmo1j2eyelwx96hql25zl5s6yr99zge4sxe32gms32
   */
  async balanceKeplr() {
    await this.checkKeplr();
    try {
      const chainId = mttCosmosJson.chainId;
      await this._keplr.enable(chainId);
      const offlineSigner = this._keplr.getOfflineSigner(chainId);
      const accounts = await offlineSigner.getAccounts();
      console.log("\u2705 Keplr \u8FDE\u63A5\u6210\u529F\uFF0C\u5730\u5740:", accounts[0].address);
      this.address = accounts[0].address;
      const lcdEndpoint = mttCosmosJson.rest;
      const response = await fetch(`${lcdEndpoint}/cosmos/bank/v1beta1/balances/${this.address}`);
      const data = await response.json();
      console.log("\u{1F4B0} \u8D26\u6237\u4F59\u989D:", data.balances);
      return new SuccessResult(data.balances);
    } catch (error) {
      return new FailureResult(null);
    }
  }
}

const api = scopeApi("ibc/core");
async function getClientState(chainnelID) {
  try {
    const tx = await api.get(`/channel/v1/channels/${chainnelID}/ports/transfer/client_state`);
    return tx;
  } catch (error) {
    console.error("getTxByHash >>>", error);
    return null;
  }
}

function createMsgConvertCoin(denom, amount, receiver, sender) {
  return {
    type: "mtt/MsgConvertCoin",
    value: {
      coin: {
        denom,
        amount
      },
      receiver,
      sender
    }
  };
}
function protoCreateMsgConvertCoin(denom, amount, receiver, sender) {
  const msg = new erc20Type.evmos.erc20.v1.MsgConvertCoin({
    coin: new coin.cosmos.base.v1beta1.Coin({
      denom,
      amount
    }),
    receiver,
    sender
  });
  return {
    message: msg,
    path: "mtt.erc20.v1.MsgConvertCoin"
  };
}
function createTxMsgConvertCoin(chain, sender, fee, memo, params) {
  const feeObject = (0, eip712_1.generateFee)(fee.amount, fee.denom, fee.gas, sender.accountAddress);
  const types = (0, eip712_1.generateTypes)(eip712_1.MSG_CONVERT_COIN_TYPES);
  const msg = createMsgConvertCoin(params.denom, params.amount, params.receiverHexFormatted, params.senderEvmosFormatted);
  const messages = (0, eip712_1.generateMessage)(sender.accountNumber.toString(), sender.sequence.toString(), chain.cosmosChainId, memo, feeObject, msg);
  const eipToSign = (0, eip712_1.createEIP712)(types, chain.chainId, messages);
  const msgCosmos = protoCreateMsgConvertCoin(params.denom, params.amount, params.receiverHexFormatted, params.senderEvmosFormatted);
  const tx = (0, proto_1.createTransaction)(msgCosmos, memo, fee.amount, fee.denom, parseInt(fee.gas, 10), "ethsecp256", sender.pubkey, sender.sequence, sender.accountNumber, chain.cosmosChainId);
  return {
    signDirect: tx.signDirect,
    legacyAmino: tx.legacyAmino,
    eipToSign
  };
}

function createMsgConvertERC20(contractAddress, amount, receiver, sender) {
  return {
    type: "mtt/MsgConvertERC20",
    value: {
      contract_address: contractAddress,
      amount,
      receiver,
      sender
    }
  };
}
function protoCreateMsgConvertERC20(contractAddress, amount, receiver, sender) {
  const msg = new erc20Type.evmos.erc20.v1.MsgConvertERC20({
    contract_address: contractAddress,
    amount,
    receiver,
    sender
  });
  return {
    message: msg,
    path: "mtt.erc20.v1.MsgConvertERC20"
  };
}
function createTxMsgConvertERC20(chain, sender, fee, memo, params) {
  const feeObject = (0, eip712_1.generateFee)(fee.amount, fee.denom, fee.gas, sender.accountAddress);
  const types = (0, eip712_1.generateTypes)(eip712_1.MSG_CONVERT_ERC20_TYPES);
  const msg = createMsgConvertERC20(params.contract_address, params.amount, params.receiverEvmosFormatted, params.senderHexFormatted);
  const messages = (0, eip712_1.generateMessage)(sender.accountNumber.toString(), sender.sequence.toString(), chain.cosmosChainId, memo, feeObject, msg);
  const eipToSign = (0, eip712_1.createEIP712)(types, chain.chainId, messages);
  const msgCosmos = protoCreateMsgConvertERC20(params.contract_address, params.amount, params.receiverEvmosFormatted, params.senderHexFormatted);
  const tx = (0, proto_1.createTransaction)(msgCosmos, memo, fee.amount, fee.denom, parseInt(fee.gas, 10), "ethsecp256", sender.pubkey, sender.sequence, sender.accountNumber, chain.cosmosChainId);
  return {
    signDirect: tx.signDirect,
    legacyAmino: tx.legacyAmino,
    eipToSign
  };
}

const osmosisID = "osmosis-1";
const osmosisRpc = "https://osmosis-rpc.mtt.network";
const Osmosis_2_Mtt_usdcDenom = "ibc/498A0751C798A0D9A389AA3691123DADA57DAA4FE165D5C75894505B876BA6E4";
const Mtt_2_Osmosis_usdcDenom = "ibc/247DEF7C0E022DC3FAF5EB13A38C616252B5B85651803E03710CCBD581673C87";
const Contract_Address_USDC = "0xecEEEfCEE421D8062EF8d6b4D814efe4dc898265";
const Channel_Osmosis_2_Mtt = "channel-98611";
const Channel_Mtt_2_Osmosis = "channel-3";

const gasPrice = 8e-4;
async function cosmosSimulate(req) {
  if (!window.getOfflineSigner || !window.keplr) {
    return new FailureResult(null, "Keplr extension is not installed or not enabled.");
  }
  await window.keplr.enable(osmosisID);
  const offlineSigner = window.getOfflineSigner(osmosisID);
  const { amount, receiver, sender } = req;
  const client = await SigningStargateClient.connect(osmosisRpc);
  const balance = await client.getBalance(sender, Osmosis_2_Mtt_usdcDenom);
  console.log(">>>>>>>>.", balance);
  const osmosisClient = await SigningStargateClient.connectWithSigner(
    osmosisRpc,
    offlineSigner
  );
  const transferMsg = {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
    value: {
      sourcePort: "transfer",
      sourceChannel: Channel_Osmosis_2_Mtt,
      // Osmosis 到 MTT 的通道 ID
      token: {
        denom: Osmosis_2_Mtt_usdcDenom,
        amount
      },
      sender,
      receiver,
      timeoutTimestamp: dayjs().add(10, "minute").unix().toString() + "000000000"
      // 设置超时时间
    }
  };
  try {
    const gasEstimate = await osmosisClient.simulate(
      sender,
      [transferMsg],
      ""
    );
    const adjustedGas = Math.ceil(gasEstimate * 1.2);
    const fee = Math.ceil(adjustedGas * gasPrice);
    console.log("Simulate Result:", fee);
    return new SuccessResult(fee);
  } catch (error) {
    console.error("Simulate Error:", error);
    return new FailureResult(error);
  }
}
async function msgTransferForcosmos2mtt(req) {
  if (!window.getOfflineSigner || !window.keplr) {
    return new FailureResult(null, "Keplr extension is not installed or not enabled.");
  }
  await window.keplr.enable(osmosisID);
  const offlineSigner = window.getOfflineSigner(osmosisID);
  const { amount, receiver, sender } = req;
  const client = await SigningStargateClient.connect(osmosisRpc);
  const balance = await client.getBalance(sender, Osmosis_2_Mtt_usdcDenom);
  console.log(">>>>>>>>.", balance);
  const osmosisClient = await SigningStargateClient.connectWithSigner(
    osmosisRpc,
    offlineSigner
  );
  const transferMsg = {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
    value: {
      sourcePort: "transfer",
      sourceChannel: Channel_Osmosis_2_Mtt,
      // Osmosis 到 MTT 的通道 ID
      token: {
        denom: Osmosis_2_Mtt_usdcDenom,
        amount
      },
      sender,
      receiver,
      timeoutTimestamp: dayjs().add(10, "minute").unix().toString() + "000000000"
      // 设置超时时间
    }
  };
  const gasEstimate = await osmosisClient.simulate(sender, [transferMsg], "");
  const adjustedGas = Math.ceil(gasEstimate * 1.2);
  const fee = {
    amount: [
      {
        denom: Osmosis_2_Mtt_usdcDenom,
        amount: "84"
      }
    ],
    // 手续费
    gas: adjustedGas.toString()
  };
  try {
    const result = await osmosisClient.signAndBroadcast(
      sender,
      [transferMsg],
      fee
    );
    console.log("Transaction Result:", result);
    return new SuccessResult(result);
  } catch (error) {
    console.error("Transaction Error:", error);
    return new FailureResult(error);
  }
}
async function msgTransferFormtt2cosmos(req) {
  return await globalStaking(async (accountAddress, publicKeyResp) => {
    const memo = "ibcTransfer mtt -> cosmos";
    const oldFee = await getTxFee();
    const chain = getTxChain();
    const sender = getTxSender(accountAddress, publicKeyResp);
    const revisionResp = await getClientState(Channel_Mtt_2_Osmosis);
    const height = Number(revisionResp?.identified_client_state?.client_state?.latest_height?.revision_height || 0) + 1e3;
    const version = revisionResp?.identified_client_state?.client_state?.latest_height?.revision_number || "1";
    const { amount, receiver } = req;
    const params = {
      sourcePort: "transfer",
      sourceChannel: Channel_Mtt_2_Osmosis,
      receiver,
      amount,
      denom: Mtt_2_Osmosis_usdcDenom,
      revisionHeight: height,
      revisionNumber: version,
      timeoutTimestamp: dayjs().add(10, "minute").unix().toString() + "000000000"
    };
    const oldTx = createTxIBCMsgTransfer(chain, sender, oldFee, memo, params);
    console.log("oldTx >>>>>>>>>>>>", oldTx);
    const gasLimit = await simulate(oldTx);
    if (!gasLimit?.isSuccess) {
      return gasLimit;
    }
    const fee = await getTxFee(gasLimit?.data);
    console.log(chain, sender, fee, memo, params);
    const tx = createTxIBCMsgTransfer(chain, sender, fee, memo, params);
    console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
    return new SuccessResult(tx);
  });
}
async function msgConvertForcosmos2evm(req) {
  return await globalStaking(async (accountAddress, publicKeyResp) => {
    const memo = "ConvertCoin";
    const oldFee = await getTxFee();
    const chain = getTxChain();
    const sender = getTxSender(accountAddress, publicKeyResp);
    const { amount, address } = req;
    const cosmosAddress = evmToCosmos(address);
    const params = {
      denom: Mtt_2_Osmosis_usdcDenom,
      amount,
      receiverHexFormatted: address,
      senderEvmosFormatted: cosmosAddress
    };
    const oldTx = createTxMsgConvertCoin(chain, sender, oldFee, memo, params);
    console.log("oldTx >>>>>>>>>>>>", oldTx);
    const gasLimit = await simulate(oldTx);
    if (!gasLimit?.isSuccess) {
      return gasLimit;
    }
    const fee = await getTxFee(gasLimit?.data);
    console.log(chain, sender, fee, memo, params);
    const tx = createTxMsgConvertCoin(chain, sender, fee, memo, params);
    console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
    return new SuccessResult(tx);
  });
}
async function msgConvertForevm2cosmos(req) {
  return await globalStaking(async (accountAddress, publicKeyResp) => {
    const memo = "ConvertERC20";
    const oldFee = await getTxFee();
    const chain = getTxChain();
    const sender = getTxSender(accountAddress, publicKeyResp);
    const { amount, address } = req;
    const cosmosAddress = evmToCosmos(address);
    const params = {
      contract_address: Contract_Address_USDC,
      amount,
      receiverEvmosFormatted: cosmosAddress,
      senderHexFormatted: address
    };
    const oldTx = createTxMsgConvertERC20(chain, sender, oldFee, memo, params);
    console.log("oldTx >>>>>>>>>>>>", oldTx);
    const gasLimit = await simulate(oldTx);
    if (!gasLimit?.isSuccess) {
      return gasLimit;
    }
    const fee = await getTxFee(gasLimit?.data);
    console.log(chain, sender, fee, memo, params);
    const tx = createTxMsgConvertERC20(chain, sender, fee, memo, params);
    console.log("tx >>>>>>>>>>>>", tx, gasLimit, fee);
    return new SuccessResult(tx);
  });
}

export { MiningStaking, VirtualDetail, VirtualMine, WalletEmitEnum, WalletKeplr, WebSocketMiningBlock, checkTxHash as checkTxHashByCosomos, cosmosSimulate, cosmosToEvm, evmToCosmos, getBlanceFromValidator, getRedelegate, getTxByHash, msgConvertForcosmos2evm, msgConvertForevm2cosmos, msgTransferForcosmos2mtt, msgTransferFormtt2cosmos, mttToValoper, mttToValoperV2 };
